import { DataTableService } from './../../../shared/data-table/data-table.service';
import { DataTableValidators } from './../../../shared/data-table/validators';
import { CgpSnackbarService } from './../../../shared/cgp-snackbar/cgp-snackbar.service';
import { FileDownloadService } from './../../../shared/file-download/file-download.service';
import { DataTableComponent } from './../../../shared/data-table/data-table.component';
import { Component, OnInit, ViewChild } from '@angular/core';
import { TprDuplicateDialogComponent } from './tpr-dialogs/tpr-duplicate/tpr-duplicate-dialog.component';
import { TprDuplicateRevDialogComponent } from './tpr-dialogs/tpr-duplicate-rev/tpr-duplicate-rev-dialog.component';

import { TprecmApiService } from '../../../../modules/api/tprecm-api.service';
import { ViewUpdateTprApiService } from '../../../../modules/api/view-update-tpr-api.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

import { forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { LazyLoadEvent } from 'primeng/api/public_api';
import { ColumnDef, PageOptions } from '../../../shared/data-table/data-table.interface';
import { TprCommentModalComponent } from './tpr-dialogs/tpr-comment/tpr-comment-modal.component';
import { TprAddModalComponent } from './tpr-dialogs/tpr-add/tpr-add-modal.component';
import { ToastrService } from 'ngx-toastr';
import { TprReasonModalComponent } from './tpr-dialogs/tpr-reasons/tpr-reasons-modal.component';
import { TprNecModalComponent } from './tpr-dialogs/tpr-nec/tpr-nec-modal.component';
import { TprShowFilesModalComponent } from './tpr-dialogs/tpr-files/tpr-show-files-modal.component';
import { filter, finalize, defaultIfEmpty } from 'rxjs/operators';
import { TprDeleteComponent } from './tpr-dialogs/tpr-delete/tpr-delete.component';
import { ViewUpdateTpr } from './view-update-tpr.class';
import { TprecmAuthorizationService } from '../authorization/tprecm-authorization.service';

const DROP_DOWN_SORT_FIELD = {
   'programId': 'programName',
   'typeId': 'typeName',
   'engineerId': 'lastFirstName',
   'spanId': 'span'
};

const TPRECM_MODAL_PANEL_CLASS = 'tprecm-modal-panel';

@Component({
   templateUrl: './view-update-tpr.template.html',
   styleUrls: ['../tprecm.style.scss']
})
export class ViewUpdateTprComponent implements OnInit {

   @ViewChild('toolsGrid') toolsGrid: DataTableComponent;

   tools: any = [];
   total = 0;

   loading = true;
   resourced = false;
   inactive = false;

   // Dropdown list within the grid
   programs: any[] = [];
   fixtureTypes: any[] = [];
   engineers: any[] = [];
   constFollowupEngineers: any[] = [];
   designSourceReps: any[] = [];
   spans: any[] = [];
   searchBarInput: any;
   searchFixtureNo: string;

   pageOptions: PageOptions = this.dataTableService.pageOptionsDefaultSort('programName');

   /**
   * Column names and values for the span/classes table.
   * Matches the DTO.
   *
   * @type {any[]}
   * @memberof SpanMaintenanceModalComponent
   */
   columns: ColumnDef[] = [
      {
         field: 'programId', name: 'Program Name', type: 'dropdown',
         optionsList: this.programs, optionsListName: 'programNameYear', optionsListField: 'id',
         placeHolderField: 'programName'
      },
      {
         field: 'toolNo', name: 'Checking Fixture No', width: '8em', validators: [
            DataTableValidators.maxLength(20),
            DataTableValidators.required(),
            DataTableValidators.regex('^[a-zA-Z0-9_-]*$', 'Only A-Z, 0-9, -, and _ are allowed characters.')
         ]
      },
      { field: 'toolName', name: 'Tool Name', validators: [DataTableValidators.maxLength(50), DataTableValidators.required()] },
      {
         field: 'stablePartCode1', name: 'CSPC LH or Single', width: '6em', validators: [DataTableValidators.maxLength(50), DataTableValidators.required()],
         tooltip: 'Common Stable Part Code Left Hand or Single'
      },
      { field: 'stablePartCode2', name: 'CSPC RH', width: '6em', validators: [DataTableValidators.maxLength(50), DataTableValidators.required()], tooltip: 'Common Stable Part Code Right Hand' },
      { field: 'partNumber', name: 'Part No LH', width: '6em', validators: [DataTableValidators.maxLength(8), DataTableValidators.required()] },
      { field: 'partNumber2', name: 'Part No RH', width: '6em', validators: [DataTableValidators.maxLength(8), DataTableValidators.required()] },
      {
         field: 'typeId', name: 'Fixture Type', type: 'dropdown', placeHolderField: 'typeName',
         optionsList: this.fixtureTypes, optionsListName: 'typeName', optionsListField: 'id'
      },
      {
         field: 'engineerId', name: 'MSE', type: 'dropdown', placeHolderField: 'lastFirstName',
         optionsList: this.engineers, optionsListName: 'lastFirstName', optionsListField: 'id', width: '8em'
      },
      {
         field: 'cfe', name: 'CFE', type: 'searchable-text',
         optionsList: this.constFollowupEngineers, optionsListName: 'cfe', optionsListField: 'cfe', tooltip: 'Construction Follow-up Engineer',
         validators: DataTableValidators.maxLength(100), width: '8em'
      },
      {
         field: 'dsRep', name: 'Design Src Rep', type: 'searchable-text',
         optionsList: this.designSourceReps, optionsListName: 'dsRep', optionsListField: 'dsRep', tooltip: 'Design Source Representative',
         validators: DataTableValidators.maxLength(100), width: '8em'
      },
      {
         field: 'spanId', name: 'Class', width: '4em', type: 'dropdown',
         optionsList: this.spans, optionsListName: 'span', optionsListField: 'id',
         cellHoverInfo: (span: any) => {
            return [
               { title: 'Class', data: span.span },
               { title: 'Design Weeks', data: span.designWeeks },
               { title: 'Build Weeks', data: span.buildWeeks },
               { title: 'Design Buffer', data: span.designBuffer },
               { title: 'Build Buffer', data: span.buildBuffer },
               { title: 'Math Units', data: span.mathUnits },
               {
                  title: 'Examples',
                  data: `${span.examples ? span.examples : ''}
                        ${span.examples1 ? ', ' + span.examples1 : ''}
                        ${span.examples2 ? ', ' + span.examples2 : ''}
                        ${span.examples3 ? ', ' + span.examples3 : ''}`
               }
            ];
         }
      },
   ];

   selectedTpr: ViewUpdateTpr = new ViewUpdateTpr();

   generalInfoLists: any = {};

   constructor(
      private readonly tprecmApiService: TprecmApiService,
      private readonly viewUpdateTprApiService: ViewUpdateTprApiService,
      private readonly snackbar: CgpSnackbarService,
      private readonly download: FileDownloadService,
      private readonly toastr: ToastrService,
      private readonly dialog: MatDialog,
      public readonly router: Router,
      private readonly auth: TprecmAuthorizationService,
      private readonly dataTableService: DataTableService
   ) { }

   ngOnInit() {
      this.loadData();
      if (this.router.url === '/tprecm/view-update-tpr/inactive') {
         this.inactive = true;
      }

      if ((this.router.url === '/tprecm/view-update-tpr/re-source') || this.router.url === '/tprecm/view-update-tpr/inactive') {
         this.columns.forEach(val => { val.editable = false; val.headerHighlight = false; });
         this.columns.forEach(val => {
            if (val.field === 'toolNo' || val.field === 'toolName' || val.field === 'stablePartCode1' ||
               val.field === 'stablePartCode2' || val.field === 'partNumber' || val.field === 'partNumber2' ||
               val.field === 'cfe' || val.field === 'dsRep' || val.field === 'spanId') {
               return (val.type = 'readonly');
            }
         });
      }

      this.auth.tprFieldFullAccess()
         .pipe(filter(access => !access))
         .subscribe(() => {
            this.columns.forEach(col => col.editable = false);
            this.columns.find((col) => col.field === 'typeId').editable = this.auth.getAuthorizationByField('fixtTypeName');
         });
   }

   loadData() {
      this.loading = true;

      forkJoin([
         this.tprecmApiService.getTprPrograms(),
         this.tprecmApiService.getFixtureTypes(),
         this.tprecmApiService.getEngineers(),
         this.tprecmApiService.getConstEngineers(),
         this.tprecmApiService.getDesignSourceReps(),
         this.tprecmApiService.getSpan(),

         this.viewUpdateTprApiService.getConstSource(),
         this.viewUpdateTprApiService.getDesignSource(),
         this.viewUpdateTprApiService.getFirstUserSource(),
         this.viewUpdateTprApiService.getUserSource(),
         this.viewUpdateTprApiService.getfixtureLocation()
      ]).pipe(finalize(() => this.loading = false))
         .subscribe(response => {
            this.programs = response[0];
            this.fixtureTypes = response[1];
            this.engineers = response[2];
            this.constFollowupEngineers = response[3];
            this.designSourceReps = response[4];
            this.spans = response[5];
            this.columns[0].optionsList = this.programs;
            this.columns[7].optionsList = this.fixtureTypes;
            this.columns[8].optionsList = this.engineers;
            this.columns[9].optionsList = this.constFollowupEngineers;
            this.columns[10].optionsList = this.designSourceReps;
            this.columns[11].optionsList = this.spans;

            this.generalInfoLists.constSources = response[6];
            this.generalInfoLists.designSources = response[7];
            this.generalInfoLists.firstUserSources = response[8];
            this.generalInfoLists.userSources = response[9];
            this.generalInfoLists.fixtureLocs = response[10];

            this.loadTools();
         });
   }

   loadTools() {
      this.loading = true;

      // If an individual tpr is loaded
      if (this.router.url.split('/')[3] !== undefined && this.router.url.split('/')[3] !== 're-source' && this.router.url.split('/')[3] !== 'inactive') {
         this.viewUpdateTprApiService.getIndividualTpr(this.router.url.split('/')[3])
            .pipe(
               finalize(() => this.loading = false),
               defaultIfEmpty({ data: [], totalCount: 0 })
            ).subscribe(response => {
               this.tools = response.data;
               this.total = response.totalCount;
               if (this.total > 0) {
                  this.selectedTpr = this.tools[0];
                  this.toolsGrid.selections = [this.tools[0]];
               }
            });
      }
      if (this.router.url.split('/')[3] !== undefined && this.router.url.split('/')[3] === 'inactive') {


         this.viewUpdateTprApiService.getInactiveTpr(this.getParams(), this.pageOptions)
            .pipe(
               finalize(() => this.loading = false),
               defaultIfEmpty({ data: [], totalCount: 0 })
            ).subscribe((response: any) => {
               this.tools = response.data;
               this.total = response.totalCount;
               if (this.total > 0) {
                  this.selectedTpr = this.tools[0];
                  this.toolsGrid.selections = [this.tools[0]];
                  this.loadIndividualTool(this.selectedTpr.tprToolId);
               }
            });
      } else {// If a page of tprs is loaded
         this.resourced = this.router.url.split('/')[3] === 're-source';
         this.inactive = this.router.url.split('/')[2] === 'inactive';

         this.viewUpdateTprApiService.getTpr(this.getParams(), this.pageOptions)
            .pipe(
               finalize(() => this.loading = false),
               defaultIfEmpty({ data: [], totalCount: 0 })
            ).subscribe((response: any) => {
               this.tools = response.data;
               this.total = response.totalCount;
               if (this.total > 0) {
                  this.selectedTpr = this.tools[0];
                  this.toolsGrid.selections = [this.tools[0]];
                  this.loadIndividualTool(this.selectedTpr.tprToolId);
               }
            });
      }
   }

   loadIndividualTool(tprToolId: number) {
      this.loading = true;
      this.viewUpdateTprApiService.getIndividualToolById(tprToolId)
         .pipe(
            finalize(() => this.loading = false),
            defaultIfEmpty({ data: [], totalCount: 0 })
         ).subscribe((response: any) => {
            if (this.tools.some(tool => tool.toolNo === this.selectedTpr.toolNo)) {
               this.selectedTpr = response.data[0];
            }
         });
   }

   pageOptionsChanged(event: LazyLoadEvent): boolean {
      const sortField: string = DROP_DOWN_SORT_FIELD[event.sortField] || event.sortField;
      return [
         this.pageOptions.order !== (event.sortOrder === 1 ? 'asc' : 'desc'),
         this.pageOptions.size !== event.rows,
         this.pageOptions.sort !== sortField,
         this.pageOptions.page !== event.first / this.pageOptions.size
      ].some(v => v);
   }

   onLazyLoad(event: LazyLoadEvent) {
      if (!this.pageOptionsChanged(event)) {
         return;
      }
      const sortField: string = DROP_DOWN_SORT_FIELD[event.sortField] || event.sortField;

      this.pageOptions.order = event.sortOrder === 1 ? 'asc' : 'desc';
      this.pageOptions.size = event.rows;
      this.pageOptions.sort = sortField;
      this.pageOptions.page = event.first / this.pageOptions.size;

      this.loadTools();
   }

   private getParam(obj: any, id: string): any | undefined {
      return obj ? obj[id] : undefined;
   }

   private getParams() {
      const selections = JSON.parse(sessionStorage.getItem('selections')) || { areas: [] };
      const programIds = selections.programs.map((p: any) => p.id);

      return {
         programIds: programIds.length > 0 ? programIds : undefined,
         chkBiw: selections.areas.includes('BIW'),
         chkDei: selections.areas.includes('DEI'),
         chkGae: selections.areas.includes('GAE'),
         engineerId: this.getParam(selections.engineer, 'id'),
         partNumber: this.getParam(selections.partNoLH, 'partNumber'),
         stablePartCode1: this.getParam(selections.cspcLH, 'stablePartCode1'),
         toolNo: this.getParam(selections.gageNo, 'toolNo'),
         cfe: this.getParam(selections.constEngineer, 'cfe'),
         dsRep: this.getParam(selections.designSourceRep, 'dsRep'),
         partNumber2: this.getParam(selections.partNoRH, 'partNumber2'),
         stablePartCode2: this.getParam(selections.cspcRH, 'stablePartCode2'),
         typeId: this.getParam(selections.fixtureType, 'id'),
         firstUserSourceId: this.getParam(selections.firstUserSource, 'id'),
         designSourceId: this.getParam(selections.designSource, 'id'),
         userSourceId: this.getParam(selections.userSource, 'id'),
         constSourceId: this.getParam(selections.buildSource, 'id'),
         toolName: selections.keyword || undefined,
         reSourced: +this.resourced,
         filterColumn: { toolNoFilter: this.searchFixtureNo },

      };
   }

   onGridSelectionChange(event) {
      if (event && this.selectedTpr && event.toolId === this.selectedTpr.toolId) {
         return;
      }

      this.selectedTpr = event;
      if (event) {
         this.loadIndividualTool(event.tprToolId);
      }
   }

   onBackButtonClicked() {
      this.tprecmApiService.goToLandingPage();
   }

   updateSelectedTpr(newInfo: any) {
      if (!newInfo) {
         this.loadIndividualTool(this.selectedTpr.tprToolId);
      } else {
         this.selectedTpr = { ...this.selectedTpr, ...newInfo };
      }
   }

   editField(event) {
      if (event.data.toolNo != null) {
         event.data.toolNo = event.data.toolNo.toUpperCase();
      }
      if (event.data.toolName != null) {
         event.data.toolName = event.data.toolName.toUpperCase();
      }
      if (event.data.stablePartCode1 != null) {
         event.data.stablePartCode1 = event.data.stablePartCode1.toUpperCase();
      }
      if (event.data.stablePartCode2 != null) {
         event.data.stablePartCode2 = event.data.stablePartCode2.toUpperCase();
      }
      if (event.data.partNumber != null) {
         event.data.partNumber = event.data.partNumber.toUpperCase();
      }
      if (event.data.partNumber2 != null) {
         event.data.partNumber2 = event.data.partNumber2.toUpperCase();
      }

      this.viewUpdateTprApiService.updateTprGrid({ ...event.data, calcFieldsRequired: true }, event.data.tprToolId)
         .pipe(finalize(() => this.loadIndividualTool(event.data.tprToolId))).subscribe();
   }

   onTprAddedUpdate(message: string) {
      this.toastr.success(message);
      this.pageOptions.sort = 'tprToolId';
      this.pageOptions.order = 'desc';
      this.loadTools();
   }

   onDuplicateClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to create a duplicate TPR for.');
         return;
      }

      const dialogRef = this.dialog.open(TprDuplicateDialogComponent, {
         disableClose: true,
         data: { selectedToolId: this.selectedTpr.toolId }
      });

      dialogRef.afterClosed()
         .subscribe((tool: any) => {
            if (tool) {
               this.tools.unshift(tool);
               this.selectedTpr = tool;
               this.toolsGrid.selections = [tool];
               this.toastr.success('The TPR was duplicated successfully.');
            }
         });
   }

   onDuplicateRevClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to create a duplicate (Rev) TPR for.');
         return;
      }
      const dialogRef = this.dialog.open(TprDuplicateRevDialogComponent, {
         disableClose: true,
         data: {
            selectedToolId: this.selectedTpr.toolId,
            toolNo: this.selectedTpr.toolNo,
         }
      });

      dialogRef.afterClosed()
         .subscribe((tool: any) => {
            if (tool) {
               this.tools.unshift(tool);
               this.selectedTpr = tool;
               this.toolsGrid.selections = [tool];
               this.toastr.success('The TPR was duplicated (rev) successfully.');
            }
         });
   }

   onAddNewTprClick() {
      const dialogRef = this.dialog.open(TprAddModalComponent, {
         disableClose: true,
         data: {
            programs: this.programs,
            fixtures: this.fixtureTypes,
            classes: this.spans,
            engineers: this.engineers,
            designSources: this.generalInfoLists.designSources,
         }
      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.onTprAddedUpdate('The TPR was added successfully.'));
   }

   private fixtureBuilt(selected: ViewUpdateTpr) {
      return ['modelPerc', 'mathPerc', 'detail1Perc', 'checkedPerc', 'opsPerc', 'fabricationPerc',
         'ncPrgmPerc', 'machiningPerc', 'assemblyPerc', 'certPerc', 'finalAsmPerc'].every(v => selected[v] >= 100) &&
         selected.designActualFinish && selected.buildActualFinish;
   }

   onDeleteTprClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to delete a TPR for.');
         return;
      }
      const dialogRef = this.dialog.open(TprDeleteComponent, {
         disableClose: true,
         data: {
            toolId: this.selectedTpr.toolId,
            fixtureBuilt: this.fixtureBuilt(this.selectedTpr) && this.selectedTpr.revisionTpr !== 1
         },

      });

      dialogRef.afterClosed()
         .pipe(filter(Boolean))
         .subscribe(() => this.loadTools());
   }

   onShowCommentsClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to show comments for.');
         return;
      }
      if (!this.selectedTpr.toolId) {
         this.toastr.error('Please select a row before clicking the Show Comments button.');
         return;
      }

      this.dialog.open(TprCommentModalComponent, {

         disableClose: true,
         panelClass: TPRECM_MODAL_PANEL_CLASS,
         height: '54vh',
         width: '54vw',
         data: {
            selectedToolId: this.selectedTpr.tprToolId,
            fixtureNo: this.selectedTpr.toolNo,
            partNumber: this.selectedTpr.partNumber
         }
      });
   }

   onReasonCodesClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to view the reason codes for.');
         return;
      }
      if (!this.selectedTpr.toolId) {
         this.toastr.error('Please select a row before clicking the Reason Codes button.');
         return;
      }

      this.dialog.open(TprReasonModalComponent, {

         disableClose: true,
         height: '54vh',
         width: '54vw',
         data: {
            selectedToolId: this.selectedTpr.tprToolId,
            fixtureNo: this.selectedTpr.toolNo,
            partNumber: this.selectedTpr.partNumber,
            reSourced: this.resourced
         }
      });

   }

   onShowFilesClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to show files for.');
         return;
      }
      if (!this.selectedTpr.toolId) {
         this.toastr.error('Please select a row before clicking the Show Files button.');
         return;
      }

      this.dialog.open(TprShowFilesModalComponent, {
         disableClose: true,
         panelClass: TPRECM_MODAL_PANEL_CLASS,
         height: '74vh',
         width: '74vw',
         data: {
            selectedToolId: this.selectedTpr.tprToolId,
            fixtureNo: this.selectedTpr.toolNo,
            spans: this.spans,
            partNumber: this.selectedTpr.partNumber,
            readonly: this.resourced
         }
      });

   }

   onPrintTprClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to print TPR for.');
         return;
      }
      if (!this.selectedTpr.toolId) {
         this.toastr.error('Please select a row before printing TPR');
         return;
      }

      const date = new Date();

      const ref = this.snackbar.showSnackbar({
         message: 'Downloading Attachment...',
         action: 'Dismiss',
         duration: null
      });

      const url = `tpr/print?tprToolId=${this.selectedTpr.tprToolId}`;
      const filename = `rptPrintTpr_${this.selectedTpr.tprToolId}_${date.toISOString().split('T')[0]}_${date.getHours()}_${date.getMinutes()}_${date.getSeconds()}.pdf`;
      this.download.downloadFile(url, filename)
         .subscribe(() => ref.dismiss());
   }

   onNecClick() {
      // If no rows are selected do nothing
      if (!this.selectedTpr || Object.keys(this.selectedTpr).length === 0) {
         this.toastr.error('Please select a tool to view the NEC reports for.');
         return;
      }
      if (!this.selectedTpr.toolId) {
         this.toastr.error('Please select a row before clicking the NEC button.');
         return;
      }

      this.dialog.open(TprNecModalComponent, {

         disableClose: true,
         panelClass: TPRECM_MODAL_PANEL_CLASS,
         height: '54vh',
         width: '54vw',
         data: {
            selectedTprToolId: this.selectedTpr.tprToolId,
            selectedToolId: this.selectedTpr.toolId,
            fixtureNo: this.selectedTpr.toolNo,
            programName: this.selectedTpr.programNameYear
         }
      });
   }

   onUndoResourceClick() {
      const toolId = this.selectedTpr.toolId;

      this.viewUpdateTprApiService.undoTprResource(toolId)
         .subscribe(() => {
            this.toastr.success('The change has been made. The TPR is no longer recorded as re-sourced.');
            this.loadTools();
         });
   }

   onActiveTprClick() {
      const toolId = this.selectedTpr.toolId;
      this.viewUpdateTprApiService.activateTpr(toolId).subscribe(() => {
         this.toastr.success('The TPR has been successfully marked as active.');
         this.loadTools();
      });
   }

   searchFixtureNumber(event: any) {
      this.searchFixtureNo = event.value;
      this.loadTools();
   }

   clearSearch() {
      this.searchBarInput = '';
      this.searchFixtureNo = '';
      this.loadTools();
   }
}
